import { Component, OnInit, Input } from '@angular/core';
import * as emiGlobals from 'app/globals';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-apply-loan-pop-up',
  templateUrl: './apply-loan-pop-up.component.html',
  styleUrls: ['./apply-loan-pop-up.component.css']
})
export class ApplyLoanPopUpComponent implements OnInit {

  @Input() offer;
  @Input() inputvalue;
  @Input() whtasAppNumber;
  @Input() Messenger;
  agentInfo: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.getPageData();
  }
  getPageData() {
    try {
      if (localStorage.getItem(emiGlobals.agentInfo) && localStorage.getItem(emiGlobals.agentInfo)!=undefined){
        this.agentInfo = JSON.parse(localStorage.getItem(emiGlobals.agentInfo));
      }
    } catch (error) {
      console.log(error);
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/calculators/home-loan-comparison-calculator/apply-loan-pop-up/apply-loan-pop-up.component.ts